/* TinsleTime — theme.js (no dependencies) */
(() => {
  'use strict';

  const TT = window.TT || {};
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  /* ---------- Money -------------------------------------------------- */
  function formatMoney(cents, format = TT.moneyFormat || '€{{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = Number(cents) / 100;
    const fmt = (n, decimals, thou = ',', dec = '.') => {
      const [i, d] = n.toFixed(decimals).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? dec + d : '');
    };
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return value.toFixed(2);
    const map = {
      amount: fmt(value, 2),
      amount_no_decimals: fmt(value, 0),
      amount_with_comma_separator: fmt(value, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(value, 0, '.', ','),
      amount_with_apostrophe_separator: fmt(value, 2, "'", '.'),
      amount_with_space_separator: fmt(value, 2, ' ', ',')
    };
    return format.replace(match[0], map[match[1]] ?? fmt(value, 2));
  }
  TT.formatMoney = formatMoney;

  /* ---------- Christmas cutoff countdown ----------------------------- */
  function cutoffDate() {
    if (!TT.cutoff) return null;
    const d = new Date(TT.cutoff + 'T23:59:59');
    return isNaN(d) ? null : d;
  }
  function renderCountdowns() {
    const end = cutoffDate();
    $$('[data-countdown]').forEach((el) => {
      if (!end) { el.closest('[data-countdown-wrap]')?.setAttribute('hidden', ''); return; }
      const ms = end - new Date();
      if (ms <= 0) {
        const late = el.closest('[data-countdown-wrap]');
        if (late && late.dataset.lateText) late.innerHTML = late.dataset.lateText;
        return;
      }
      const d = Math.floor(ms / 864e5);
      const h = Math.floor((ms % 864e5) / 36e5);
      const m = Math.floor((ms % 36e5) / 6e4);
      el.textContent = d > 0 ? `${d}d ${h}h ${m}m` : `${h}h ${m}m`;
    });
  }
  renderCountdowns();
  setInterval(renderCountdowns, 30000);

  /* ---------- Delivery ETA on product page --------------------------- */
  $$('[data-eta]').forEach((el) => {
    const min = Number(el.dataset.min || 2);
    const max = Number(el.dataset.max || 4);
    const addBusinessDays = (date, days) => {
      const d = new Date(date);
      while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) days--; }
      return d;
    };
    const opts = { weekday: 'short', day: 'numeric', month: 'short' };
    const now = new Date();
    const from = addBusinessDays(now, min).toLocaleDateString(undefined, opts);
    const to = addBusinessDays(now, max).toLocaleDateString(undefined, opts);
    const out = $('[data-eta-range]', el);
    if (out) out.textContent = `${from} – ${to}`;
  });

  /* ---------- Mobile nav --------------------------------------------- */
  $$('[data-menu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const nav = document.getElementById(btn.getAttribute('aria-controls'));
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      nav?.classList.toggle('is-open', !open);
    });
  });

  /* ---------- "/" focuses search, like on GitHub --------------------- */
  document.addEventListener('keydown', (e) => {
    if (e.key !== '/' || e.metaKey || e.ctrlKey) return;
    const tag = document.activeElement?.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || document.activeElement?.isContentEditable) return;
    const input = $('[data-search-input]');
    if (input) { e.preventDefault(); input.focus(); }
  });

  /* ---------- Tabs ---------------------------------------------------- */
  $$('[data-tabs]').forEach((tabs) => {
    const buttons = $$('[role="tab"]', tabs);
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach((b) => {
          const selected = b === btn;
          b.setAttribute('aria-selected', String(selected));
          b.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      });
      btn.addEventListener('keydown', (e) => {
        const i = buttons.indexOf(btn);
        let next = null;
        if (e.key === 'ArrowRight') next = buttons[(i + 1) % buttons.length];
        if (e.key === 'ArrowLeft') next = buttons[(i - 1 + buttons.length) % buttons.length];
        if (next) { e.preventDefault(); next.focus(); next.click(); }
      });
    });
  });

  /* ---------- Quantity steppers -------------------------------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    const step = Number(btn.dataset.qtyStep);
    const min = Number(input.min || 0);
    input.value = Math.max(min, Number(input.value || 0) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Advent graph ------------------------------------------- */
  $$('[data-advent]').forEach((root) => {
    const days = $$('.advent__day', root);
    const panel = $('[data-advent-panel]', root);
    const today = new Date();
    const year = Number(root.dataset.year) || today.getFullYear();
    const preview = root.dataset.preview === 'true';

    const show = (btn) => {
      days.forEach((d) => d.setAttribute('aria-pressed', String(d === btn)));
      const locked = btn.classList.contains('is-locked');
      $('[data-advent-title]', panel).textContent = locked ? `Day ${btn.dataset.day} — still wrapped` : btn.dataset.title;
      $('[data-advent-text]', panel).textContent = locked
        ? `Opens on ${btn.dataset.day} December. Watch for drops and we'll email you the code that morning.`
        : btn.dataset.text;
      const codeWrap = $('[data-advent-code-wrap]', panel);
      const link = $('[data-advent-link]', panel);
      if (!locked && btn.dataset.code) {
        codeWrap.hidden = false;
        $('code', codeWrap).textContent = btn.dataset.code;
      } else codeWrap.hidden = true;
      if (!locked && btn.dataset.url) { link.hidden = false; link.href = btn.dataset.url; } else link.hidden = true;
    };

    days.forEach((btn) => {
      const day = Number(btn.dataset.day);
      const date = new Date(year, 11, day);
      const isToday = date.toDateString() === today.toDateString();
      const unlocked = preview || date <= today;
      if (!unlocked) btn.classList.add('is-locked');
      if (isToday) btn.classList.add('is-today');
      btn.addEventListener('click', () => show(btn));
    });

    const start = days.find((d) => d.classList.contains('is-today')) || days.find((d) => !d.classList.contains('is-locked')) || days[0];
    if (start && panel) show(start);
  });

  $$('[data-copy]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const text = btn.parentElement.querySelector('code')?.textContent || '';
      try { await navigator.clipboard.writeText(text); } catch (_) {}
      const old = btn.textContent;
      btn.textContent = 'Copied';
      setTimeout(() => (btn.textContent = old), 1400);
    });
  });

  /* ---------- Product form ------------------------------------------- */
  $$('[data-product-form]').forEach((form) => {
    const dataEl = document.getElementById(form.dataset.variantsId);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = $('input[name="id"]', form);
    const atc = $$('[data-atc]');
    const priceEl = $('[data-price]');
    const compareEl = $('[data-compare]');
    const saveEl = $('[data-save]');
    const stockEl = $('[data-stock]');
    const lowThreshold = Number(form.dataset.lowStock || 5);

    const selected = () => $$('fieldset[data-option]', form).map((fs) => $('input:checked', fs)?.value);

    const update = () => {
      const opts = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      $$('fieldset[data-option]', form).forEach((fs, i) => {
        const legendVal = $('[data-selected-value]', fs);
        if (legendVal) legendVal.textContent = opts[i] || '';
        $$('input', fs).forEach((input) => {
          const test = opts.slice(); test[i] = input.value;
          const match = variants.find((x) => x.options.every((o, j) => o === test[j]));
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      if (!v) {
        atc.forEach((b) => { b.disabled = true; b.querySelector('[data-atc-text]').textContent = 'Unavailable'; });
        return;
      }
      idInput.value = v.id;
      atc.forEach((b) => {
        b.disabled = !v.available;
        b.querySelector('[data-atc-text]').textContent = v.available ? b.dataset.labelAdd : 'Sold out';
      });
      if (priceEl) {
        priceEl.textContent = formatMoney(v.price);
        priceEl.classList.toggle('price--sale', v.compare_at_price > v.price);
        $$('[data-sticky-price]').forEach((el) => (el.textContent = formatMoney(v.price)));
      }
      if (compareEl) {
        compareEl.hidden = !(v.compare_at_price > v.price);
        compareEl.textContent = v.compare_at_price ? formatMoney(v.compare_at_price) : '';
      }
      if (saveEl) {
        const save = v.compare_at_price > v.price ? v.compare_at_price - v.price : 0;
        saveEl.hidden = !save;
        saveEl.textContent = save ? `Save ${formatMoney(save)}` : '';
      }
      if (stockEl) {
        const qty = v.inventory_quantity;
        const tracked = v.inventory_management === 'shopify' && v.inventory_policy === 'deny';
        stockEl.className = 'stock';
        if (!v.available) { stockEl.innerHTML = '<span class="dot" style="background:var(--tt-muted)"></span> Sold out for this season'; }
        else if (tracked && qty > 0 && qty <= lowThreshold) { stockEl.classList.add('stock--low'); stockEl.innerHTML = `<span class="dot"></span> Only ${qty} left — they won't be restocked before Christmas`; }
        else { stockEl.innerHTML = '<span class="dot"></span> In stock, ships within 24h'; }
      }
      if (v.featured_media) {
        const thumb = $(`[data-media-id="${v.featured_media.id}"]`);
        thumb?.click();
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };

    form.addEventListener('change', (e) => { if (e.target.closest('fieldset[data-option]')) update(); });
    update();

    form.addEventListener('submit', async (e) => {
      if (!TT.cartDrawer) return; // fall back to normal POST
      e.preventDefault();
      const btn = $('[data-atc]', form);
      btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(TT.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number($('[name="quantity"]', form)?.value || 1), properties: Object.fromEntries(Array.from(new FormData(form).entries()).filter(([k]) => k.startsWith('properties[')).map(([k, v]) => [k.slice(11, -1), v])) }] })
        });
        if (!res.ok) {
          const err = await res.json();
          alert(err.description || 'Could not add to cart');
          return;
        }
        await Cart.refresh();
        Cart.open();
      } finally { btn.removeAttribute('aria-busy'); }
    });
  });

  // Quick-add buttons on product cards
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    try {
      const res = await fetch(TT.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.quickAdd), quantity: 1 }] })
      });
      if (res.ok) { await Cart.refresh(); Cart.open(); }
    } finally { btn.disabled = false; }
  });

  /* ---------- Gallery ------------------------------------------------- */
  $$('[data-gallery]').forEach((g) => {
    const main = $('[data-gallery-main] img', g);
    $$('[data-media-id]', g).forEach((btn) => {
      btn.addEventListener('click', () => {
        $$('[data-media-id]', g).forEach((b) => b.setAttribute('aria-current', String(b === btn)));
        if (main) { main.src = btn.dataset.full; main.srcset = ''; main.alt = btn.querySelector('img')?.alt || ''; }
      });
    });
  });

  /* ---------- Sticky add to cart (mobile) ---------------------------- */
  const sticky = $('[data-sticky-atc]');
  const mainAtc = $('[data-product-form] [data-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(mainAtc);
    $('[data-atc]', sticky)?.addEventListener('click', () => $('[data-product-form]').requestSubmit());
  }

  /* ---------- Cart drawer -------------------------------------------- */
  const drawer = $('[data-cart-drawer]');
  TT.cartDrawer = Boolean(drawer && drawer.dataset.enabled === 'true');

  const Cart = {
    state: null,
    async fetch() {
      const res = await fetch(TT.routes.cart + '.js', { headers: { Accept: 'application/json' } });
      this.state = await res.json();
      return this.state;
    },
    async change(line, quantity) {
      const res = await fetch(TT.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      this.state = await res.json();
      this.render();
    },
    async refresh() { await this.fetch(); this.render(); },
    open() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      $('.drawer__close', drawer)?.focus();
    },
    close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    render() {
      const cart = this.state;
      if (!cart) return;
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      renderMeters(cart.total_price);
      if (!drawer) return;
      const body = $('[data-cart-lines]', drawer);
      const wrapId = Number(drawer.dataset.giftwrapId || 0);
      const wrapToggle = $('[data-giftwrap]', drawer);
      if (wrapToggle) wrapToggle.checked = cart.items.some((i) => i.variant_id === wrapId);
      $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);
      $('[data-cart-foot]', drawer).hidden = cart.item_count === 0;
      if (cart.item_count === 0) {
        body.innerHTML = `<div class="empty"><svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25Zm1.75-.25a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Z"/></svg><p><strong>Your cart is empty.</strong><br><span class="muted">Nothing under the tree yet.</span></p><a class="btn btn--primary" href="/collections/all">Browse gifts</a></div>`;
        return;
      }
      body.innerHTML = cart.items.map((item, i) => `
        <div class="line">
          <div class="line__img">${item.image ? `<img src="${item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="" width="72" height="72" loading="lazy">` : ''}</div>
          <div>
            <a class="line__title" href="${item.url}">${escapeHtml(item.product_title)}</a>
            ${item.variant_title && !item.product_has_only_default_variant ? `<div class="line__variant">${escapeHtml(item.variant_title)}</div>` : ''}
            <div class="line__controls">
              <div class="qty">
                <button type="button" data-line-step="-1" data-line="${i + 1}" aria-label="Decrease">−</button>
                <input type="number" value="${item.quantity}" min="0" aria-label="Quantity" data-line-input="${i + 1}">
                <button type="button" data-line-step="1" data-line="${i + 1}" aria-label="Increase">+</button>
              </div>
              <button type="button" class="line__remove" data-line-remove="${i + 1}">Remove</button>
            </div>
          </div>
          <div class="line__price">
            <span class="price">${formatMoney(item.final_line_price)}</span>
            ${item.original_line_price > item.final_line_price ? `<div class="price__compare">${formatMoney(item.original_line_price)}</div>` : ''}
          </div>
        </div>`).join('');
    }
  };
  TT.Cart = Cart;

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  function renderMeters(total) {
    const goal = Number(TT.freeShipping || 0);
    $$('[data-ship-meter]').forEach((m) => {
      if (!goal) { m.hidden = true; return; }
      const left = Math.max(0, goal - total);
      const pct = Math.min(100, Math.round((total / goal) * 100));
      $('span', $('.progress', m)).style.width = pct + '%';
      m.classList.toggle('is-complete', left === 0);
      $('[data-ship-text]', m).innerHTML = left === 0
        ? 'Free shipping unlocked — delivered before Christmas.'
        : `You're <strong>${formatMoney(left)}</strong> away from free shipping.`;
    });
  }

  if (drawer) {
    $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
      if (!TT.cartDrawer) return;
      e.preventDefault(); Cart.refresh(); Cart.open();
    }));
    $$('[data-cart-close]', drawer).forEach((el) => el.addEventListener('click', () => Cart.close()));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') Cart.close(); });

    drawer.addEventListener('click', (e) => {
      const step = e.target.closest('[data-line-step]');
      const remove = e.target.closest('[data-line-remove]');
      if (step) {
        const line = Number(step.dataset.line);
        const qty = Cart.state.items[line - 1].quantity + Number(step.dataset.lineStep);
        Cart.change(line, Math.max(0, qty));
      }
      if (remove) Cart.change(Number(remove.dataset.lineRemove), 0);
    });
    drawer.addEventListener('change', (e) => {
      const input = e.target.closest('[data-line-input]');
      if (input) Cart.change(Number(input.dataset.lineInput), Math.max(0, Number(input.value)));
    });

    const wrap = $('[data-giftwrap]', drawer);
    wrap?.addEventListener('change', async () => {
      const id = Number(drawer.dataset.giftwrapId);
      if (!id) return;
      if (wrap.checked) {
        await fetch(TT.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
        await Cart.refresh();
      } else {
        const idx = Cart.state.items.findIndex((i) => i.variant_id === id);
        if (idx > -1) await Cart.change(idx + 1, 0);
      }
    });

    const note = $('[data-cart-note]', drawer);
    let t;
    note?.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(() => fetch(TT.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }), 500);
    });
  }

  // Initial meter render on cart page / drawer
  if ($('[data-ship-meter]')) Cart.fetch().then(() => Cart.render());
})();
